import {action} from 'typesafe-actions';
import {RegisterActionsTypes} from "./types";
import {UserRegistrationRequest} from "../../models/User";

export const fetchRequest = (userDetails: UserRegistrationRequest) => action(RegisterActionsTypes.FETCH_REQUEST, userDetails);
export const fetchSuccess = () => action(RegisterActionsTypes.FETCH_SUCCESS);
export const fetchError = (errors: string[]) => action(RegisterActionsTypes.FETCH_ERROR, errors);
